import React from 'react';

import { ComponentProps } from '../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../utils/styles';
import './post-timestamp.scss';

export interface IPostTimestamp extends ComponentProps {
  timestamp: string; // ISO format like '2022-10-18T09:01:22.423Z'
  timestampUtcIt?: string; // ISO format like '2022-10-18T11:01:22.423+02:00'
  time?: string | null;
  date?: string | null;
}

const classNames = (): IClassNames =>
  makeClassNames({
    PostTimestamp: 'post__timestamp',
    PostTimestampTime: 'post__timestamp-time',
    PostTimestampDate: 'post__timestamp-date',
  });

const PostTimestamp: React.FC<IPostTimestamp> = ({ timestampUtcIt, timestamp, time, date }) => {
  const cn = classNames();

  return (
    <div className={cn.PostTimestamp}>
      {time && (
        <time dateTime={timestampUtcIt || timestamp} className={cn.PostTimestampTime}>
          {time}
        </time>
      )}
      {date && (
        <time dateTime={timestampUtcIt || timestamp} className={cn.PostTimestampDate}>
          {date}
        </time>
      )}
    </div>
  );
};

export default PostTimestamp;
